import { HTMLAttributes, PropsWithChildren, useMemo } from 'react';

import { useClassHelper } from '../../../../../../hooks/useClassHelper';
import { Dropdown } from '../../../../../Dropdown/Dropdown';
import { componentName } from '../../constants';

interface Props
  extends PropsWithChildren,
    HTMLAttributes<HTMLParagraphElement> {
  fontFamily: string;
  fontWeight?: 'normal' | 'bold';
}

export const Paragraph = ({
  children,
  className,
  fontFamily,
  fontWeight = 'normal',
  ...props
}: Props) => {
  const c = useClassHelper(componentName);

  return (
    <Dropdown.GoogleFont.Viewer
      fontFamily={fontFamily}
      useAsVariableWrapper={false}
    >
      <p
        className={c('__paragraph', `__paragraph--${fontWeight}`, className)}
        {...props}
      >
        {children}
      </p>
    </Dropdown.GoogleFont.Viewer>
  );
};
